// English text for the Arabic keys used with t(). Arabic is the default language; a key without an entry here
// is shown as written. Server messages that reach the screen are listed too (see lib/axios.js).
const en = {
  "جاري التحميل...": "Loading...",
  "الاسم يجب ألا يحتوي على أرقام!": "The name must not contain numbers!",
  "الوظيفة يجب ألا تحتوي على أرقام!": "The job must not contain numbers!",
  "الراتب يجب أن يكون رقمًا ولا يكون أقل من 0!": "Salary must be a number and not less than 0!",
  "جميع الحقول مطلوبة!": "All fields are required!",
  "رقم الهاتف يجب أن يبدأ بـ 077 أو 075 أو 078 ويحتوي على 11 رقمًا!":
    "The phone number must start with 077, 075 or 078 and have 11 digits!",
  "تم إضافة العامل بنجاح!": "Worker added successfully!",
  "إضافة عامل": "Add worker",
  "ادخل الاسم": "Enter the name",
  الاسم: "Name",
  "ادخل الوظيفة": "Enter the job",
  الوظيفة: "Job",
  "ادخل الراتب": "Enter the salary",
  "الراتب (بالألف)": "Salary (in thousands)",
  "ادخل رقم الهاتف": "Enter the phone number",
  "رقم الهاتف": "Phone number",
  إلغاء: "Cancel",
  حفظ: "Save",
  "أرشفة الموظف: {name}": "Archive employee: {name}",
  "يبقى سجل عمله ودفعاته وخصوماته وتقاريره كما هي، ويختفي من قوائم الموظفين النشطين ومن التسجيل اليومي.":
    "Their work, payments, deductions and reports stay as they are. They disappear from the active employee lists and from daily entry.",
  "تاريخ المغادرة": "Date of leaving",
  "السبب (اختياري)": "Reason (optional)",
  "جاري المعالجة...": "Processing...",
  أرشفة: "Archive",
  "التسجيل اليومي": "Daily entry",
  "الأسابيع والرواتب": "Weeks and salaries",
  "الاستقطاعات والسلف": "Deductions and advances",
  الدفعات: "Payments",
  الموظفون: "Employees",
  "أنواع العمل": "Work types",
  المشتريات: "Purchases",
  المواد: "Materials",
  "استيراد الموظفين": "Employee import",
  الحسابات: "Accounts",
  "إعدادات الشركة": "Company settings",
  "روابط كشف الراتب": "Payslip links",
  إضافة: "Created",
  تعديل: "Edit",
  حذف: "Delete",
  استعادة: "Restore",
  استيراد: "Import",
  مشاركة: "Share",
  الراتب: "Salary",
  الهاتف: "Phone",
  الحالة: "Status",
  "سبب المغادرة": "Reason for leaving",
  التاريخ: "Date",
  "نوع العمل": "Work type",
  سيارة: "Car",
  الاتجاه: "Direction",
  "مبلغ السيارة": "Car amount",
  "الأجر اليومي": "Daily wage",
  الخصم: "Deduction",
  البقشيش: "Tip",
  "بداية الأسبوع": "Week start",
  "نهاية الأسبوع": "Week end",
  المبلغ: "Amount",
  "المبلغ الأصلي": "Original amount",
  المتبقي: "Remaining",
  السبب: "Reason",
  المشتري: "Buyer",
  "السعر الكلي": "Total price",
  العملة: "Currency",
  المنتجات: "Products",
  "الأجر اليومي للنوع": "Daily wage for the type",
  "اسم الشركة": "Company name",
  العنوان: "Address",
  "هاتف الشركة": "Company phone",
  الشعار: "Logo",
  "اسم المستخدم": "Username",
  الدور: "Role",
  القناة: "Channel",
  المستلم: "Recipient",
  "حالة التسليم": "Delivery status",
  "ينتهي في": "Expires at",
  الملف: "File",
  "إجمالي الصفوف": "Total rows",
  "تم استيراده": "Imported",
  "تم تخطيه": "Skipped",
  فشل: "Failed",
  "نوع المادة": "Material type",
  "رقم الموظف": "Employee number",
  "تاريخ الدفع": "Payment date",
  المصدر: "Source",
  "تاريخ النهاية يجب أن يكون بعد تاريخ البداية.": "The end date must be after the start date.",
  "هذه الصفحة لمالك الحساب فقط.": "This page is for the account owner only.",
  "يبدأ السجل من {date}. لا تتوفر أحداث أقدم من ذلك، ولا تُسجَّل تسجيلات الدخول وعمليات التصدير وعرض الإيصالات.":
    "The log starts on {date}. Earlier events are not available, and sign-ins, exports and receipt views are not recorded.",
  "لا توجد أحداث مسجلة بعد.": "No events have been recorded yet.",
  "تصفية سجل العمليات": "Filter the audit log",
  "من تاريخ": "From date",
  "إلى تاريخ": "To date",
  المستخدم: "User",
  الكل: "All",
  القسم: "Section",
  العملية: "Action",
  تطبيق: "Apply",
  "سجل العمليات": "Audit log",
  "لا توجد عمليات مطابقة.": "No matching events.",
  بواسطة: "By",
  "غير معروف": "Unknown",
  الموظف: "Employee",
  السجل: "Record",
  "إخفاء التفاصيل": "Hide details",
  "عرض التفاصيل": "Show details",
  الحقل: "Field",
  قبل: "Before",
  بعد: "After",
  مخفي: "Hidden",
  "ترقيم الصفحات": "Pagination",
  السابق: "Previous",
  "صفحة {page} من {pages}": "Page {page} of {pages}",
  التالي: "Next",
  "القيم معروضة كما هي مخزنة. مبالغ الرواتب تُخزَّن بالألف دينار.":
    "Values are shown as stored. Salary amounts are stored in thousands of dinars.",
  "حدث خطأ أثناء تسجيل الدخول": "An error occurred while signing in",
  "تسجيل الدخول": "Sign in",
  "اسم المعرف": "Username",
  "ادخل اسم المعرف": "Enter the username",
  "رمز الحساب": "Account code",
  "ادخل الرمز": "Enter the code",
  "إنشاء حساب": "Create account",
  "كلمة المرور وتأكيد كلمة المرور غير متطابقين": "Password and password confirmation do not match",
  "حدث خطأ أثناء إنشاء الحساب": "An error occurred while creating the account",
  "ادخل اسم المستخدم": "Enter the username",
  "معرف المستخدم": "User ID",
  "ادخل معرف المستخدم": "Enter the user ID",
  "كلمة المرور": "Password",
  "ادخل كلمة المرور": "Enter the password",
  "تأكيد كلمة المرور": "Confirm password",
  "ادخل تأكيد كلمة المرور": "Enter the password confirmation",
  موافق: "OK",
  "لا توجد بيانات لعرضها": "No data to display",
  "الاسم:": "Name:",
  "نوع العمل:": "Work type:",
  "الأجر اليومي:": "Daily wage:",
  "اتجاه العمل:": "Work direction:",
  "لا يوجد سيارة": "No car",
  "مبلغ السيارة:": "Car amount:",
  "التاريخ:": "Date:",
  "تقرير الرواتب": "Salary report",
  "قسم المواد": "Materials",
  "قسم المشتريات": "Purchases",
  "قسم الاستقطاع": "Deductions",
  "تقارير الموظفين": "Employee reports",
  "لوحة التحكم": "Dashboard",
  "أنواع العمل والأجور": "Work types and wages",
  "اختر نوع الطعام.": "Choose the food type.",
  "اختر نوع الطعام": "Choose the food type",
  "لا توجد أنواع طعام بعد. أضف الأنواع التي تشتريها أولاً ثم اخترها هنا.":
    "There are no food types yet. Add the types you buy first, then choose them here.",
  "إضافة أنواع الطعام": "Add food types",
  "أنواع الطعام": "Food types",
  "أدخل اسم نوع الطعام.": "Enter the food type name.",
  "المبلغ غير صالح. اكتب رقماً صحيحاً.": "The amount is not valid. Type a whole number.",
  "اسم النوع": "Type name",
  "السعر المعتاد (د.ع)": "Usual price (IQD)",
  "بدون سعر": "No price",
  "لا توجد أنواع طعام بعد.": "There are no food types yet.",
  "تغيير النوع أو حذفه لا يغيّر الطعام المسجّل سابقاً.":
    "Changing or deleting a type does not change food that was already recorded.",
  "هل أنت متأكد أنك تريد حذف هذا النوع؟": "Are you sure you want to delete this type?",
  "الشهر السابق": "Previous month",
  "الشهر التالي": "Next month",
  "الشهر الحالي": "Current month",
  "إضافة طعام": "Add food",
  "إجمالي الشهر": "Month total",
  "إجمالي الطعام لشهر {month}": "Food total for {month}",
  "لا توجد مصاريف طعام في هذا الشهر.": "No food expenses in this month.",
  "إجمالي اليوم": "Day total",
  "تعديل {name}": "Edit {name}",
  "حذف {name}": "Delete {name}",
  "إجمالي كل شهر": "Total of every month",
  "هل أنت متأكد أنك تريد حذف هذا العنصر؟": "Are you sure you want to delete this item?",
  "أدخل السعر.": "Enter the price.",
  "المبلغ كبير جداً.": "The amount is too large.",
  "أدخل نوع الطعام.": "Enter the food type.",
  "يجب أن يكون السعر أكبر من صفر.": "The price must be greater than zero.",
  "تعديل عنصر طعام": "Edit food item",
  "نوع الطعام": "Food type",
  "السعر (د.ع)": "Price (IQD)",
  "حذف هذا العنصر": "Remove this item",
  "إضافة نوع آخر لنفس اليوم": "Add another type for the same day",
  "إجمالي هذا اليوم": "Total for this day",
  الطعام: "Food",
  "تسجيل أنواع الطعام وأسعارها كل يوم ومتابعة إجمالي كل شهر.":
    "Record the food types and prices each day and follow each month's total.",
  "الأسبوع يبدأ من يوم الجمعة وينتهي يوم الخميس. لعرض أسابيع أخرى اختر تاريخ بداية يوافق يوم الجمعة.":
    "The week starts on Friday and ends on Thursday. To view other weeks, choose a start date that is a Friday.",
  "تحديد أنواع العمل والأجر اليومي لكل نوع، ويُستخدم في التسجيل اليومي.":
    "Set the work types and the daily wage of each, used in the daily entry.",
  "فتح الصفحة": "Open page",
  "اختر القسم الذي تريد العمل عليه": "Choose the section you want to work on",
  "إضافة الموظفين وتعديل بياناتهم وأرشفتهم.": "Add employees, edit their data and archive them.",
  "تسجيل أيام العمل اليومية وأجورها لكل موظف.": "Record each employee's daily work and wages.",
  "كشف الرواتب الأسبوعي وتسليم الرواتب وإضافة الإكراميات.":
    "The weekly salary sheet: pay salaries and add bonuses.",
  "تسجيل المواد والكميات المسلّمة للموظفين.":
    "Record the materials and quantities given to employees.",
  "تسجيل المشتريات وأسعارها ومتابعة إجماليها بكل عملة.":
    "Record purchases and prices and follow the total in each currency.",
  "تسجيل الاستقطاعات على الموظفين ومتابعتها.": "Record deductions from employees and follow them.",
  "تقرير مالي مفصّل لكل موظف مع طباعة وتصدير وكشف راتب.":
    "A detailed financial report per employee with print, export and payslip.",
  "كل العمليات التي أُجريت في النظام ومن قام بها.":
    "Every operation made in the system and who made it.",
  "شركة العلى للمقاولات العامة المحدودة": "Alaula General Contracting Company Ltd",
  "فتح القائمة": "Open menu",
  "تسجيل الخروج": "Sign out",
  "التنقل الرئيسي": "Main navigation",
  "القائمة الرئيسية": "Main menu",
  القائمة: "Menu",
  "إغلاق القائمة": "Close menu",
  بحث: "Search",
  "تعذر تحميل أنواع العمل.": "Could not load the work types.",
  'تم حفظ أجر "{name}".': 'Saved the wage of "{name}".',
  "تعذر حفظ الأجر.": "Could not save the wage.",
  'تمت إضافة نوع العمل "{name}".': 'Added the work type "{name}".',
  "تعذر إضافة نوع العمل.": "Could not add the work type.",
  "أنواع العمل والأجور اليومية": "Work types and daily wages",
  "تُدخل الأجور بالألف (25 تعني 25,000 د.ع) وتُستخدم تلقائياً في التسجيل اليومي. تغيير الأجر لا يعدّل السجلات المحفوظة سابقاً.":
    "Wages are entered in thousands (25 means 25,000 IQD) and are used automatically in daily entry. Changing a wage does not change records already saved.",
  "غير محدد": "Not set",
  "الأجر اليومي لـ": "Daily wage for",
  "جاري الحفظ...": "Saving...",
  "نوع عمل جديد": "New work type",
  "اسم نوع العمل": "Work type name",
  اختياري: "Optional",
  "تمت الأرشفة. ما زال له رصيد غير مدفوع {owed} وخصومات قائمة {deductions}؛ يمكن تسويتها من تقرير الرواتب وقسم الاستقطاع.":
    "Archived. They still have an unpaid balance of {owed} and outstanding deductions of {deductions}; settle them from the salary report and the deductions section.",
  "تمت أرشفة الموظف. بقيت سجلاته كما هي.":
    "The employee was archived. Their records are unchanged.",
  "تمت استعادة الموظف إلى القائمة النشطة.": "The employee was restored to the active list.",
  "تم إضافة الموظف بنجاح!": "Employee added successfully!",
  "فشل في إضافة الموظف: ": "Failed to add the employee: ",
  "حدث خطأ ما": "Something went wrong",
  "تم حذف الموظف بنجاح!": "Employee deleted successfully!",
  "فشل في حذف الموظف: ": "Failed to delete the employee: ",
  "تم تحديث بيانات الموظف بنجاح!": "Employee details updated successfully!",
  "فشل في تحديث بيانات الموظف: ": "Failed to update the employee details: ",
  مؤرشف: "Archived",
  التسلسل: "No.",
  الإجراءات: "Actions",
  "حالة الموظفين": "Employee status",
  "استيراد موظفين": "Import employees",
  "اضافة عامل جديد": "Add new worker",
  'هل أنت متأكد أنك تريد حذف العامل "{name}"؟':
    'Are you sure you want to delete the worker "{name}"?',
  "حقل الموظف ومبلغ الخصم مطلوبان!": "The employee and the deduction amount are required!",
  "تم إضافة الخصم بنجاح!": "Deduction added successfully!",
  "فشل في إضافة الخصم: ": "Failed to add the deduction: ",
  "إضافة خصم": "Add deduction",
  "اختر الموظف": "Select the employee",
  "لا يوجد موظفين متاحين": "No employees available",
  "مبلغ الخصم (بالألف)": "Deduction amount (in thousands)",
  "سبب الخصم (اختياري)": "Deduction reason (optional)",
  "مبلغ السداد الجزئي لا يمكن أن يتجاوز إجمالي الخصومات المتاحة ({total}).":
    "The partial payment cannot exceed the total available deductions ({total}).",
  الاستقطاع: "Deduction",
  "سداد كامل": "Full payment",
  "سداد جزئي": "Partial payment",
  "اضافة خصم": "Add deduction",
  "سداد جزئي للموظف:": "Partial payment for the employee:",
  "المبلغ المطلوب سداده": "Amount to pay",
  تأكيد: "Confirm",
  "سجل عمل": "Work record",
  "أسبوع (دفع/إكرامية)": "Week (payment/tip)",
  سلفة: "Advance",
  دفعة: "Payment",
  "بيانات الموظف": "Employee data",
  "نوع عمل": "Work type",
  مشتريات: "Purchases",
  الأجر: "Wage",
  السيارة: "Car",
  الإكرامية: "Tip",
  الإجمالي: "Total",
  "، ": ", ",
  "سجل التعديلات": "Change history",
  "آخر 100 تغيير على بيانات هذا الموظف المالية: من غيّر ماذا ومتى. لا يشمل التغييرات التي سبقت تفعيل السجل.":
    "The last 100 changes to this employee's financial data: who changed what and when. It does not include changes made before the log was enabled.",
  "تعذر تحميل سجل التعديلات.": "Could not load the change history.",
  "لا توجد تعديلات مسجّلة بعد.": "No changes recorded yet.",
  الوقت: "Time",
  الإجراء: "Action",
  العنصر: "Item",
  التفاصيل: "Details",
  "الموظف غير موجود.": "The employee does not exist.",
  "تعذر تحميل التقرير.": "Could not load the report.",
  "إكراميات أسبوعية": "Weekly tips",
  "الإجمالي العام المستحق": "Grand total earned",
  "العودة إلى قائمة الموظفين": "Back to the employee list",
  "طباعة / PDF": "Print / PDF",
  "كشف راتب PDF": "Payslip PDF",
  "إعادة المحاولة": "Try again",
  "تقرير مالي: {name}": "Financial report: {name}",
  "الفترة: {range}": "Period: {range}",
  "{from} إلى {to}": "{from} to {to}",
  البداية: "the start",
  اليوم: "today",
  "كل السجلات": "All records",
  "غادر في": "Left on",
  "تاريخ التسجيل في النظام": "Registered in the system on",
  "غير متوفر": "Not available",
  "تصفية حسب التاريخ": "Filter by date",
  "كل الفترات": "All periods",
  "جاري التحديث...": "Updating...",
  "الفترة المعروضة: {from} إلى {to}": "Period shown: {from} to {to}",
  "الفترة المعروضة: كل السجلات": "Period shown: all records",
  "الملخص المالي": "Financial summary",
  "إجمالي المستحق": "Total earned",
  "أجور + سيارة + إكراميات (لم يُستلم بالضرورة)": "Wages + car + tips (not necessarily received)",
  "إجمالي المدفوع": "Total paid",
  "أسابيع مسجّلة «مدفوع» في النظام": 'Weeks marked "paid" in the system',
  "الرصيد المتبقي": "Remaining balance",
  "المستحق − المدفوع": "Earned − paid",
  "الخصومات القائمة": "Outstanding deductions",
  "سلف وخصومات لم تُطبَّق بعد": "Advances and deductions not yet applied",
  "الصافي بعد الخصومات": "Net after deductions",
  "الرصيد المتبقي − الخصومات القائمة": "Remaining balance − outstanding deductions",
  "يوم/أيام لها أكثر من سجل في الفترة (تُحسب جميعها كما هي مسجّلة).":
    "day(s) with more than one record in the period (all are counted as recorded).",
  "سجل بأجر صفر أو أقل.": "record(s) with a zero or lower wage.",
  "سلفة بمبلغ كبير جداً (100,000 ألف أو أكثر). تأكد أنها أُدخلت بوحدة الألف كباقي الرواتب.":
    "advance(s) of a very large amount (100,000 thousand or more). Make sure it was entered in thousands like the other salaries.",
  "سجل بخصم سالب (لا يُحتسب ضمن الخصومات القائمة).":
    "record(s) with a negative deduction (not counted in outstanding deductions).",
  "الأرباح حسب نوع العمل": "Earnings by work type",
  "الدفعات تُسجَّل أسبوعياً ولا ترتبط بنوع العمل، لذلك لا تُعرض موزّعة عليه.":
    "Payments are recorded weekly and are not tied to a work type, so they are not shown split by it.",
  "لا توجد سجلات عمل في هذه الفترة.": "No work records in this period.",
  الأيام: "Days",
  الأجور: "Wages",
  المستحق: "Earned",
  "سجل العمل": "Work history",
  "كل سجل يمثل يوم عمل؛ الساعات غير مسجّلة في النظام. الأجر المطبّق هو الأجر المحفوظ وقت التسجيل وليس أجر اليوم.":
    "Each record is one work day; hours are not recorded in the system. The applied wage is the wage saved at the time of entry, not today's wage.",
  "الأجر المطبّق": "Applied wage",
  مدفوع: "Paid",
  "غير مدفوع": "Unpaid",
  "سجل المدفوعات": "Payment history",
  "لا يوجد جدول دفعات مستقل: تُحسب من الأسابيع المعلّمة «مدفوع». عند تحديد فترة تُحتسب أيام الأسبوع الواقعة داخلها فقط، والأسابيع التي تتجاوزها تظهر بعلامة «جزئي».":
    'There is no separate payments table: they are calculated from the weeks marked "paid". When a period is selected, only the week\'s days inside it are counted, and weeks that extend beyond it are marked "partial".',
  "لا يوجد جدول دفعات مستقل: تُحسب من الأسابيع المعلّمة «مدفوع». «تاريخ التسجيل» هو آخر تحديث للسجل الأسبوعي وقد لا يطابق يوم الاستلام الفعلي.":
    'There is no separate payments table: they are calculated from the weeks marked "paid". "Registration date" is the last update of the weekly record and may not match the actual day of receipt.',
  "لا توجد مدفوعات مسجّلة في هذه الفترة.": "No payments recorded in this period.",
  الأسبوع: "Week",
  جزئي: "Partial",
  "تاريخ التسجيل": "Registration date",
  السجلات: "Records",
  "الأجور والسيارة": "Wages and car",
  إكرامية: "Tip",
  "المبلغ المستلم": "Amount received",
  "طباعة قسيمة الأسبوع {week}": "Print the payslip for the week {week}",
  قسيمة: "Payslip",
  "الدفعات المسجّلة فعلياً": "Payments actually recorded",
  "تُسجَّل الدفعة بمبلغها وتاريخها عند تعليم الأسبوع «مدفوع». الصفوف «مستخرجة» اشتُقّت من الأسابيع المدفوعة قبل تفعيل هذا السجل.":
    'A payment is recorded with its amount and date when a week is marked "paid". Rows marked "backfilled" were derived from weeks paid before this log was enabled.',
  "لا توجد دفعات مسجّلة في السجل بعد.": "No payments recorded in the ledger yet.",
  مسجّلة: "Recorded",
  مستخرجة: "Backfilled",
  "المسجّل فعلياً": "Actually recorded",
  "مستخرج من السجل السابق": "Derived from the earlier record",
  "الخصومات والسلف": "Deductions and advances",
  "الجزء المطبَّق من السلفة يُعرض للاطلاع فقط ولا يُخصم مرة ثانية؛ يُحسب الجزء القائم فقط. الخصم اليومي يخزّن المبلغ القائم فقط.":
    "The applied part of an advance is shown for information only and is not deducted again; only the outstanding part is counted. A daily deduction stores only the outstanding amount.",
  السلف: "Advances",
  "لا توجد سلف في هذه الفترة.": "No advances in this period.",
  المطبَّق: "Applied",
  "الخصومات اليومية القائمة": "Outstanding daily deductions",
  "لا توجد خصومات يومية قائمة في هذه الفترة.": "No outstanding daily deductions in this period.",
  "المبلغ القائم": "Outstanding amount",
  "إجمالي الخصومات القائمة (سلف + يومية)": "Total outstanding deductions (advances + daily)",
  "الإكراميات الأسبوعية": "Weekly tips",
  "الإكرامية تخص الأسبوع وليس نوع عمل محدداً، وهي مشمولة في المستحق.":
    "A tip belongs to the week, not to a specific work type, and is included in the earned amount.",
  "المشتريات المسجّلة باسم الموظف": "Purchases recorded under the employee's name",
  "تُربط المشتريات بالاسم فقط، ولا تدخل في الرصيد أو الخصومات. كل مشترى بعملته، وتُجمع كل عملة على حدة دون تحويل.":
    "Purchases are linked by name only and do not enter the balance or the deductions. Each purchase keeps its own currency and each currency is totalled separately without conversion.",
  "لا توجد مشتريات في هذه الفترة.": "No purchases in this period.",
  "إجمالي الدينار العراقي": "Total in Iraqi dinars",
  "إجمالي الدولار الأمريكي": "Total in US dollars",
  "كيف تُحسب الأرقام؟": "How are the numbers calculated?",
  "المستحق = أجر كل يوم (المحفوظ وقت التسجيل) + مبلغ السيارة + الإكراميات الأسبوعية.":
    "Earned = each day's wage (as saved at entry) + car amount + weekly tips.",
  "المدفوع = المستحق للأيام الواقعة في أسابيع معلّمة «مدفوع» + إكراميات تلك الأسابيع. يُحتسب كل يوم مرة واحدة حتى لو تداخلت الأسابيع.":
    'Paid = the earned amount for days in weeks marked "paid" + the tips of those weeks. Each day is counted once even if weeks overlap.',
  "عند تكرار السجل الأسبوعي نفسه يُعتمد آخر سجل محفوظ، كما في تقرير الرواتب.":
    "When the same weekly record is repeated, the last saved one is used, as in the salary report.",
  "الرصيد المتبقي = المستحق − المدفوع. الصافي = الرصيد المتبقي − الخصومات القائمة فقط.":
    "Remaining balance = earned − paid. Net = remaining balance − outstanding deductions only.",
  "عند تحديد فترة، تُحتسب الأيام حسب تاريخها، والإكراميات حسب تاريخ بداية الأسبوع، والسلف حسب تاريخ إنشائها.":
    "When a period is selected, days are counted by their date, tips by the week's start date, and advances by the date they were created.",
  "تعذر تحميل قائمة الموظفين.": "Could not load the employee list.",
  "اختر موظفاً لعرض تقريره": "Choose an employee to view their report",
  "قائمة الموظفين": "Employee list",
  "لا يوجد موظفون بعد.": "No employees yet.",
  "لا يوجد موظف مطابق للبحث.": "No employee matches the search.",
  "مسجّلة عند الدفع": "Recorded at payment",
  "مستخرجة من السجل السابق": "Derived from the earlier record",
  "قسيمة الراتب": "Payslip",
  "قسيمة راتب أسبوعية": "Weekly payslip",
  "اسم الموظف:": "Employee name:",
  "الوظيفة:": "Job:",
  "الأسبوع:": "Week:",
  "عدد الأيام:": "Number of days:",
  "إجمالي الأجور": "Total wages",
  "إجمالي السيارة": "Total car",
  "الإجمالي المستحق": "Total earned",
  "المبلغ المسجّل كمدفوع:": "Amount recorded as paid:",
  "تاريخ الدفع:": "Payment date:",
  "تاريخ التسجيل:": "Registration date:",
  "تنبيه: المبلغ المسجّل يختلف عن إجمالي الأيام أعلاه.":
    "Warning: the recorded amount differs from the total of the days above.",
  "توقيع المستلم": "Recipient signature",
  "توقيع المحاسب": "Accountant signature",
  "تم تسليم الرسالة إلى مزود الخدمة (لا يعني وصولها إلى الهاتف)":
    "The message was handed to the service provider (this does not mean it reached the phone)",
  "فشل الإرسال": "Sending failed",
  "خدمة الرسائل القصيرة غير مفعّلة": "The SMS service is not enabled",
  "تم إنشاء الرابط": "The link was created",
  "كشف راتب": "Payslip",
  "تعذرت المشاركة، نزّل الملف بدلاً من ذلك.": "Sharing failed, download the file instead.",
  "تم إنشاء هذا الرابط بالفعل. حدّث النافذة لإنشاء رابط جديد.":
    "This link was already created. Refresh the window to create a new one.",
  "أدخل رقم هاتف صحيحاً.": "Enter a valid phone number.",
  "تم فتح واتساب. الإرسال يتم من داخل التطبيق ولا نعرف إن وصلت الرسالة.":
    "WhatsApp was opened. Sending happens inside the app and we cannot know whether the message arrived.",
  "كشف راتب PDF: {name}": "Payslip PDF: {name}",
  "يفصل الكشف بين المبلغ المستحق (المكتسب) والمبلغ المدفوع فعلاً.":
    "The payslip separates the amount earned from the amount actually paid.",
  "معاينة كشف الراتب": "Payslip preview",
  "تنزيل PDF": "Download PDF",
  "مشاركة الملف": "Share file",
  "إنشاء رابط آمن (48 ساعة)": "Create secure link (48 hours)",
  "مشاركة الملف المباشرة غير مدعومة في هذا المتصفح. نزّل الملف أو استخدم الرابط الآمن.":
    "Direct file sharing is not supported in this browser. Download the file or use the secure link.",
  "الرابط الآمن": "Secure link",
  "ينتهي في {date}. أي شخص يملك الرابط يستطيع تنزيل الكشف حتى ذلك الوقت.":
    "Expires on {date}. Anyone with the link can download the payslip until then.",
  "نسخ الرابط": "Copy link",
  "إرسال الرابط عبر واتساب": "Send the link via WhatsApp",
  "إرسال الرابط برسالة SMS": "Send the link by SMS",
  "خدمة الرسائل القصيرة غير مفعّلة على الخادم، لذلك لا يمكن إرسال SMS الآن.":
    "The SMS service is not enabled on the server, so SMS cannot be sent now.",
  "تأكيد الإرسال": "Confirm sending",
  "رقم المستلم": "Recipient number",
  "نص الرسالة": "Message text",
  "سيُفتح واتساب برسالة تحتوي على الرابط. لا يمكن إرفاق ملف PDF تلقائياً.":
    "WhatsApp will open with a message containing the link. A PDF file cannot be attached automatically.",
  "ستُرسل رسالة نصية فيها رابط التنزيل، وليس الملف نفسه.":
    "A text message containing the download link will be sent, not the file itself.",
  إغلاق: "Close",
  "تاريخ الطباعة:": "Print date:",
  "ترقيم صفحات: {caption}": "Pagination: {caption}",
  صفحة: "Page",
  من: "of",
  "سجل)": "records)",
  "قيد الانتظار": "Pending",
  "تم التسليم": "Delivered",
  مكتمل: "Completed",
  ملغي: "Cancelled",
  قائمة: "Outstanding",
  "مخصومة بالكامل": "Fully deducted",
  "الراتب (بالألف دينار)": "Salary (in thousands of dinars)",
  "الصيغ غير مسموحة، اكتب القيمة نصاً": "Formulas are not allowed, type the value as text",
  "الاسم مطلوب": "Name is required",
  "الاسم أطول من 255 حرفاً": "Name is longer than 255 characters",
  "الوظيفة مطلوبة": "Job is required",
  "الوظيفة ليست من أنواع العمل المسجلة": "Job is not one of the registered work types",
  "الراتب مطلوب": "Salary is required",
  "الراتب ليس رقماً": "Salary is not a number",
  "الراتب خارج النطاق المسموح": "Salary is out of the allowed range",
  "الهاتف مطلوب": "Phone is required",
  "صيغة الهاتف غير صحيحة": "Phone format is invalid",
  "تعذر حفظ الصف": "The row could not be saved",
  جاهز: "Ready",
  "تم الاستيراد": "Imported",
  "مكرر (يُتخطى)": "Duplicate (skipped)",
  خطأ: "Error",
  "الهاتف مكرر في الملف (السطر {line})": "Phone repeated in the file (row {line})",
  "الهاتف مسجل للموظف {name} (رقم {id})": "Phone already belongs to {name} (id {id})",
  "استيراد موظفين من Excel": "Import employees from Excel",
  "تنزيل القالب": "Download the template",
  "ملف Excel (xlsx)": "Excel file (xlsx)",
  "لم نتعرف على أسماء الأعمدة. اختر العمود المناسب لكل حقل:":
    "The column names were not recognised. Choose the right column for each field:",
  "— اختر —": "— Choose —",
  معاينة: "Preview",
  "تم استيراد هذا الملف نفسه من قبل. الموظفون المكررون سيُتخطّون.":
    "This same file was imported before. Duplicate employees will be skipped.",
  "ملخص المعاينة": "Preview summary",
  "جاهز للاستيراد": "Ready to import",
  مكرر: "Duplicate",
  أخطاء: "Errors",
  السطر: "Row",
  "اكتمل الاستيراد": "Import complete",
  "تنزيل تقرير الأخطاء": "Download the error report",
  "تأكيد استيراد {count} موظف": "Confirm importing {count} employees",
  "الرجاء ملء جميع الحقول المطلوبة بشكل صحيح": "Please fill in all required fields correctly",
  "تمت إضافة المواد بنجاح!": "Materials added successfully!",
  "حدث خطأ أثناء إضافة المواد": "An error occurred while adding the materials",
  "إضافة مواد": "Add materials",
  "تحميل...": "Loading...",
  "يجب اختيار الموظف": "An employee must be selected",
  "المواد والكميات": "Materials and quantities",
  الكمية: "Quantity",
  "يجب إضافة مادة واحدة على الأقل": "At least one material must be added",
  "الكمية:": "Quantity:",
  "الموظف:": "Employee:",
  "نوع المواد:": "Material type:",
  "لا توجد بيانات متاحة": "No data available",
  "تم تحديث المواد بنجاح!": "Materials updated successfully!",
  "حدث خطأ أثناء تحديث المواد": "An error occurred while updating the materials",
  "تعديل المواد": "Edit materials",
  "نوع المواد": "Material type",
  "حدث خطأ أثناء حذف المواد": "An error occurred while deleting the materials",
  "هل أنت متأكد أنك تريد حذف هذه المواد؟": "Are you sure you want to delete these materials?",
  "اضافة مواد": "Add materials",
  "لا توجد مواد حتى الآن": "No materials yet",
  "أدخل سعر المنتج.": "Enter the product price.",
  "السعر غير صالح. استخدم أرقاماً فقط.": "The price is not valid. Use digits only.",
  "لا يمكن أن يكون السعر سالباً.": "The price cannot be negative.",
  "الدولار يقبل خانتين عشريتين كحد أقصى.": "US dollars accept at most two decimal places.",
  "الدينار العراقي لا يقبل كسوراً: اكتب رقماً صحيحاً.":
    "Iraqi dinars do not accept fractions: enter a whole number.",
  "السعر كبير جداً.": "The price is too large.",
  "اختر العملة أولاً.": "Choose the currency first.",
  "الرجاء ملء جميع الحقول المطلوبة.": "Please fill in all required fields.",
  "حجم الصورة يجب أن لا يتجاوز 5 ميجابايت": "The image size must not exceed 5 MB",
  "نوع الصورة غير مدعوم. يرجى استخدام صورة بصيغة JPG أو PNG":
    "Unsupported image type. Please use a JPG or PNG image",
  "تمت إضافة المشتريات بنجاح!": "Purchases added successfully!",
  "حدث خطأ أثناء إضافة المشتريات!": "An error occurred while adding the purchases!",
  "حجم الصورة كبير جداً. يرجى اختيار صورة أصغر":
    "The image is too large. Please choose a smaller image",
  "نوع الملف غير مدعوم. يرجى اختيار صورة بصيغة JPG أو PNG":
    "Unsupported file type. Please choose a JPG or PNG image",
  "إضافة مشتريات": "Add purchases",
  "اسم المشتري": "Buyer name",
  "اختر العملة": "Choose the currency",
  "لا يمكن تغيير العملة بعد إضافة منتجات. احذف المنتجات أولاً لتغييرها؛ لا يتم تحويل المبالغ تلقائياً.":
    "The currency cannot be changed after products are added. Remove the products first to change it; amounts are not converted automatically.",
  "اختر العملة قبل كتابة السعر. تغيير العملة لا يحوّل المبلغ المكتوب.":
    "Choose the currency before typing the price. Changing the currency does not convert the amount you typed.",
  "اسم المنتج": "Product name",
  "سعر المنتج": "Product price",
  السعر: "Price",
  "اختر العملة أولاً": "Choose the currency first",
  "يظهر بعد اختيار العملة": "Appears after choosing the currency",
  "صورة الإيصال": "Receipt image",
  "اسم المشتري:": "Buyer name:",
  "بلا اسم": "No name",
  "اسم المنتج:": "Product name:",
  "السعر:": "Price:",
  "المنتجات:": "Products:",
  "لا توجد منتجات": "No products",
  "السعر الإجمالي:": "Total price:",
  "عرض الصورة": "View image",
  "لا يوجد إجراء": "No action available",
  المنتج: "Product",
  "تعذر حذف العملية.": "Could not delete the operation.",
  "هل أنت متأكد أنك تريد حذف هذه العملية؟": "Are you sure you want to delete this operation?",
  "تم الدفع": "Paid",
  تسليم: "Deliver",
  "هل أنت متأكد أنك تريد تسليم هذه العملية؟": "Are you sure you want to deliver this operation?",
  "اضافة مشتريات": "Add purchases",
  "إجمالي المشتريات حسب العملة": "Purchase totals by currency",
  "إجمالي المشتريات بالدينار العراقي": "Total purchases in Iraqi dinars",
  "إجمالي المشتريات بالدولار الأمريكي": "Total purchases in US dollars",
  "كل عملة تُجمع على حدة (باستثناء المشتريات الملغاة)؛ لا تُجمع العملتان ولا يُحوَّل أحدهما إلى الآخر.":
    "Each currency is totalled separately (cancelled purchases excluded); the two currencies are never added together or converted into each other.",
  "لا توجد مشتريات حتى الآن": "No purchases yet",
  "اختر الموظف.": "Choose the employee.",
  "فشل حفظ الإكرامية. حاول مرة أخرى.": "Saving the tip failed. Try again.",
  "إضافة إكرامية": "Add tip",
  "اختر الاسم": "Choose the name",
  "مبلغ الإكرامية": "Tip amount",
  "(بالألف)": "(in thousands)",
  "مثال: 25": "Example: 25",
  ألف: "thousand",
  "اكتب المبلغ بنفس وحدة الأجور (25 تعني 25 ألف). اكتب 0 إذا لا توجد إكرامية.":
    "Enter the amount in the same unit as wages (25 means 25 thousand). Enter 0 if there is no tip.",
  "الإكرامية المحفوظة لهذا الأسبوع:": "The tip saved for this week:",
  "ألف.": "thousand.",
  "يرجى تحديد تاريخ البدء.": "Please choose the start date.",
  "اسم الموظف": "Employee name",
  "الراتب الاسبوعي": "Weekly salary",
  "الراتب الصافي": "Net salary",
  "تم تسليم الراتب بنجاح": "Salary delivered successfully",
  "فشل تسليم الراتب: ": "Failed to deliver the salary: ",
  "الأسبوع يبدأ يوم الجمعة، اختر تاريخاً يوافق يوم جمعة.":
    "The week starts on Friday; choose a date that falls on a Friday.",
  "استخدم الجمعة السابقة: {date}": "Use the Friday before: {date}",
  "القسط الأسبوعي يجب أن يكون أكبر من صفر وليس أكثر من مبلغ الخصم.":
    "The weekly installment must be more than zero and not more than the deduction.",
  "القسط الأسبوعي (بالألف) - اختياري": "Weekly installment (in thousands) - optional",
  "القسط الأسبوعي (بالألف)": "Weekly installment (in thousands)",
  "مثال: 10": "Example: 10",
  "يُقترح خصمه تلقائياً عند تسليم الراتب كل أسبوع حتى يُسدَّد المبلغ كاملاً.":
    "It is suggested automatically when a week is paid, until the full amount is repaid.",
  "القسط الأسبوعي": "Weekly installment",
  "خطة السداد": "Repayment plan",
  "خطة السداد للموظف: {name}": "Repayment plan for {name}",
  "حدّد قسطاً أسبوعياً لكل سلفة، فيُقترح خصمه تلقائياً عند تسليم الراتب. اترك الحقل فارغاً إذا لا توجد خطة.":
    "Set a weekly installment for each advance and it is suggested when the salary is paid. Leave it empty for no plan.",
  "أدخل القسط أو اتركه فارغاً بلا خطة.": "Enter the installment or leave it empty for no plan.",
  "صحّح المبالغ المعلّمة بالأحمر أولاً.": "Fix the amounts marked in red first.",
  "تم حفظ خطة السداد.": "The repayment plan was saved.",
  "لا توجد سلف مفتوحة لهذا الموظف. استقطاعات التسجيل اليومي لا تدعم خطة السداد.":
    "This employee has no open advances. Deductions from the daily register cannot have a plan.",
  "حسب خطة السداد ({amount})": "By the repayment plan ({amount})",
  "راتب الأسبوع لا يكفي للقسط كاملاً، سيُخصم المتاح فقط.":
    "The week's pay does not cover the full installment; only what is available is deducted.",
  "القسط الأسبوعي المحدد على سلف الموظف.": "The weekly installment set on the employee's advances.",
  "قسط أسبوعي: {amount}": "Weekly installment: {amount}",
  "تحديد {name}": "Select {name}",
  "تحديد للتسليم": "Select for payment",
  "تحديد كل غير المدفوعين ({n})": "Select everyone unpaid ({n})",
  "تسليم المحدّدين ({n})": "Pay selected ({n})",
  "تسليم رواتب {n} موظف": "Pay {n} employees",
  "تأكيد تسليم {n} موظف": "Confirm payment for {n} employees",
  "تم تسليم رواتب {n} موظف. إجمالي الاستقطاع: {deduction}":
    "Paid {n} employees. Total deducted: {deduction}",
  "تم تسليم {paid} وفشل {failed}.": "{paid} paid, {failed} failed.",
  "تم · المسلَّم: {paid}": "Paid · handed over: {paid}",
  "تحقق من حالة الرواتب في القائمة قبل إعادة المحاولة.":
    "Check the salaries in the list before trying again.",
  "بدون استقطاع للجميع": "No deduction for everyone",
  "حسب خطط السداد للجميع": "Repayment plans for everyone",
  "استقطاع {name}": "Deduction for {name}",
  "مبلغ الاستقطاع لـ {name} (بالألف)": "Deduction amount for {name} (in thousands)",
  "بدون استقطاع": "No deduction",
  "إجمالي الرواتب": "Total salaries",
  "إجمالي الاستقطاع": "Total deducted",
  "إجمالي المبلغ للتسليم": "Total to hand over",
  "كشف تسليم الرواتب": "Salary handout sheet",
  "الأسبوع: {start} – {end} · تاريخ التسليم: {date}":
    "Week: {start} – {end} · Handed over on: {date}",
  "المبلغ المسلَّم": "Amount handed over",
  التوقيع: "Signature",
  "أقرّ باستلام المبلغ المذكور أمام اسمي.":
    "I confirm I received the amount stated next to my name.",
  "توقيع المدير": "Manager signature",
  "طباعة كشف التسليم": "Print handout sheet",
  "ملخص سريع": "Quick summary",
  "تعذر تحميل الملخص.": "Could not load the summary.",
  "رواتب هذا الأسبوع": "This week's pay",
  "لا توجد سجلات لهذا الأسبوع": "No records this week",
  "{n} موظف": "{n} employees",
  "تم دفع الجميع": "Everyone is paid",
  "{n} موظف لم يستلموا الراتب": "{n} employees not paid yet",
  "استقطاعات على الموظفين": "Deductions owed by employees",
  "{n} موظف عليهم استقطاع": "{n} employees owe a deduction",
  "لا يوجد استقطاع": "No deductions",
  "طعام هذا الشهر": "Food this month",
  "{n} عنصر": "{n} items",
  "لا يوجد طعام هذا الشهر": "No food this month",
  "تسليم راتب {name}": "Pay {name}'s salary",
  "راتب الأسبوع": "Week's pay",
  "تعذر التحقق من استقطاعات الموظف.": "Could not check the employee's deductions.",
  "جاري التحقق من الاستقطاعات...": "Checking deductions...",
  "لا يوجد استقطاع على هذا الموظف.": "This employee has no deductions.",
  "على هذا الموظف استقطاع بقيمة": "This employee has a deduction of",
  "بدون سبب": "No reason given",
  "استقطاعات من التسجيل اليومي": "Deductions from the daily register",
  "هل تريد استقطاع مبلغ من هذا الراتب؟": "Do you want to deduct an amount from this salary?",
  "لا، تسليم الراتب كاملاً": "No, pay the full salary",
  "استقطاع الكل ({amount})": "Deduct all ({amount})",
  "المتاح للاستقطاع من هذا الراتب هو راتب الأسبوع فقط، والباقي يبقى على الموظف.":
    "Only the week's pay can be deducted from this salary; the rest stays owed by the employee.",
  "استقطاع مبلغ محدد": "Deduct a specific amount",
  "المبلغ المتبقي للتسليم": "Amount left to hand over",
  "تأكيد التسليم": "Confirm payment",
  "أدخل مبلغ الاستقطاع.": "Enter the deduction amount.",
  "يجب أن يكون المبلغ أكبر من صفر.": "The amount must be greater than zero.",
  "المبلغ أكبر من الاستقطاع المتاح ({total}).":
    "The amount is more than the available deduction ({total}).",
  "المبلغ أكبر من راتب الأسبوع ({net}).": "The amount is more than the week's pay ({net}).",
  "تم تسليم الراتب بنجاح. الاستقطاع: {deduction}، المسلَّم: {paid}":
    "Salary delivered successfully. Deducted: {deduction}, handed over: {paid}",
  "هذا الأسبوع مدفوع مسبقاً، لا يمكن استقطاع مبلغ منه.":
    "This week is already paid; nothing can be deducted from it.",
  "الاستقطاع لا يمكن أن يتجاوز راتب الأسبوع.": "The deduction cannot exceed the week's pay.",
  "الاستقطاع أكبر من المبلغ المتاح على الموظف.": "The deduction is more than the employee owes.",
  "مبلغ الاستقطاع غير صالح، استخدم أرقاماً فقط.":
    "The deduction amount is not valid; use digits only.",
  "مبلغ الاستقطاع يقبل خانتين عشريتين كحد أقصى.":
    "The deduction amount allows at most two decimals.",
  "لا يمكن أن يكون مبلغ الاستقطاع سالباً.": "The deduction amount cannot be negative.",
  "مبلغ الاستقطاع كبير جداً.": "The deduction amount is too large.",
  "المسلَّم للموظف:": "Handed to the employee:",
  "تمت إعادة فتح الأسبوع. يمكنك الآن تعديل سجلاته.":
    "The week was reopened. You can now edit its records.",
  "فشلت إعادة فتح الأسبوع.": "Reopening the week failed.",
  "تم حفظ إكرامية {name} بمبلغ {amount} ألف": "Saved a tip of {amount} thousand for {name}",
  "لم يتم الدفع": "Not paid",
  "تسليم الراتب": "Deliver salary",
  "إعادة فتح الأسبوع": "Reopen the week",
  "كشف الرواتب الأسبوعي": "Weekly salary sheet",
  "بداية الأسبوع: {date}": "Week start: {date}",
  ":اختر تاريخ البدء": "Choose the start date:",
  "اضافة اكرامية": "Add tip",
  "إجمالي المبالغ لهذا الأسبوع:": "Total amounts for this week:",
  "إعادة فتح أسبوع {name}؟ سيُسجَّل ذلك في سجل التعديلات، وعند دفعه مجدداً يُحدَّث سجل الدفع نفسه.":
    "Reopen the week of {name}? This will be recorded in the audit log, and when it is paid again the same payment record is updated.",
  "تظهر هذه البيانات في كشوف الرواتب وملفات التصدير.":
    "These details appear on payslips and exports.",
  "الشعار (PNG أو JPG حتى 1 ميجابايت)": "Logo (PNG or JPG up to 1 MB)",
  "الشعار الحالي": "Current logo",
  "إزالة الشعار": "Remove the logo",
  "تم الحفظ.": "Saved.",
  "لا يوجد أجر محدد لنوع العمل هذا. يرجى تحديده من صفحة أنواع العمل.":
    "No wage is set for this work type. Please set it from the work types page.",
  "تعديل بيانات الموظف": "Edit employee data",
  "تسجيل يومي": "Daily entry",
  "اختر نوع العمل": "Choose the work type",
  "تعذر تحميل أنواع العمل. أغلق النافذة وحاول مرة أخرى.":
    "Could not load the work types. Close the window and try again.",
  "لا يوجد أجر محدد لهذا النوع.": "No wage is set for this type.",
  "حدّده من صفحة أنواع العمل": "Set it from the work types page",
  "الأجور اليومية": "Daily wages",
  "يُحدد حسب نوع العمل": "Set by work type",
  "لديه سيارة": "Has a car",
  "بدون سيارة": "No car",
  الوجهة: "Destination",
  "ادخل الوجهة": "Enter the destination",
  "المبلغ (بالألف)": "Amount (in thousands)",
  "اختر المبلغ": "Choose the amount",
  "وجهة السيارة": "Car destination",
  "حدث خطأ أثناء جلب البيانات.": "An error occurred while fetching the data.",
  "تم تحديث البيانات بنجاح!": "Data updated successfully!",
  "تمت إضافة التسجيل اليومي بنجاح": "Daily entry added successfully",
  "حدث خطأ أثناء حفظ البيانات.": "An error occurred while saving the data.",
  "تم حذف البيانات بنجاح!": "Data deleted successfully!",
  "حدث خطأ أثناء حذف البيانات.": "An error occurred while deleting the data.",
  "تسجيل اليومي": "Daily entry",
  الخميس: "Thursday",
  الأربعاء: "Wednesday",
  الثلاثاء: "Tuesday",
  الاثنين: "Monday",
  الأحد: "Sunday",
  السبت: "Saturday",
  الجمعة: "Friday",
  "مقفل (أسبوع مدفوع)": "Locked (paid week)",
  "هذا الأسبوع مدفوع ومقفل. أعد فتحه من صفحة الرواتب إذا أردت تعديله.":
    "This week is paid and locked. Reopen it from the salaries page if you want to edit it.",
  "هل أنت متأكد أنك تريد حذف هذا السجل؟": "Are you sure you want to delete this record?",
  "جاري التصدير...": "Exporting...",
  "تصدير Excel": "Export Excel",
  "تصدير PDF": "Export PDF",
  "{n} ميجابايت": "{n} MB",
  "{n} كيلوبايت": "{n} KB",
  "JPG أو PNG، بحد أقصى 5 ميجابايت": "JPG or PNG, up to 5 MB",
  "نوع الصورة غير مدعوم. استخدم صورة بصيغة JPG أو PNG.":
    "Unsupported image type. Use a JPG or PNG image.",
  "حجم الصورة ({size}) يتجاوز الحد المسموح ({max}).":
    "The image size ({size}) exceeds the allowed limit ({max}).",
  "معاينة الصورة المختارة": "Preview of the chosen image",
  "إزالة الصورة": "Remove the image",
  إزالة: "Remove",
  "اضغط لاختيار صورة أو اسحبها هنا": "Click to choose an image or drag it here",
  "التبديل إلى الوضع الداكن": "Switch to dark mode",
  "التبديل إلى الوضع الفاتح": "Switch to light mode",
  "رقم الهاتف غير صحيح. يجب أن يكون من 10 إلى 15 رقمًا.":
    "The phone number is not valid. It must be 10 to 15 digits.",
  "تم تحديث معلومات العامل بنجاح!": "Worker information updated successfully!",
  "تحديث معلومات العامل": "Update worker information",
  "أدخل مبلغ الإكرامية (اكتب 0 إذا لا توجد إكرامية).":
    "Enter the tip amount (enter 0 if there is no tip).",
  "المبلغ غير صالح. استخدم أرقاماً فقط، مثال: 25 أو 12.5":
    "The amount is not valid. Use digits only, for example: 25 or 12.5",
  "لا يمكن أن يكون المبلغ سالباً.": "The amount cannot be negative.",
  "الحد الأقصى خانتان عشريتان بعد الفاصلة.": "At most two decimal places.",
  "هذه العملة لا تقبل كسوراً: اكتب رقماً صحيحاً.":
    "This currency does not accept fractions: enter a whole number.",
  "المبلغ كبير جداً (الحد الأقصى 99,999,999.99).":
    "The amount is too large (maximum 99,999,999.99).",
  "دينار عراقي (IQD)": "Iraqi dinar (IQD)",
  "دولار أمريكي (USD)": "US dollar (USD)",
  "تعذر إكمال العملية.": "The operation could not be completed.",
  "هذا الأسبوع مدفوع ومقفل. أعد فتح الأسبوع أولاً إذا أردت تعديله.":
    "This week is paid and locked. Reopen the week first if you want to edit it.",
  "اسم المعرف أو كلمة المرور غير صحيحة.": "The username or password is incorrect.",
  "هذه العملية متاحة لمالك الحساب فقط.": "Only the account owner can do this.",
  "هذا الموظف مؤرشف، لا يمكن تسجيل عمل أو خصم جديد له. أعده إلى الخدمة أولاً.":
    "This employee is archived, so no new work or deduction can be recorded. Restore them first.",
  "لا يمكن حذف الموظف لأن لديه سجلات (أيام عمل أو رواتب أو مواد أو خصومات). يمكنك أرشفته للحفاظ على تاريخه المالي.":
    "The employee cannot be deleted because they have records (work days, salaries, materials or deductions). Archive them to keep their financial history.",
  "تعذر قراءة الملف. استخدم ملف Excel بصيغة xlsx من القالب.":
    "The file could not be read. Use an xlsx Excel file based on the template.",
  "الملف كبير جداً (الحد 2 ميجابايت و 1000 صف).":
    "The file is too large (limit 2 MB and 1000 rows).",
  "تم تنفيذ هذا الاستيراد من قبل.": "This import has already been completed.",
  "ملف الاستيراد غير موجود.": "Import file not found.",
  "خدمة الرسائل القصيرة غير مفعّلة. أضف بيانات المزود في إعدادات الخادم أولاً.":
    "SMS is not enabled. Add the provider settings on the server first.",
  "انتهت صلاحية الرابط أو تم إلغاؤه.": "The link has expired or was revoked.",
  "الشعار يجب أن يكون صورة PNG أو JPG لا تتجاوز 1 ميجابايت.":
    "The logo must be a PNG or JPG image up to 1 MB.",
  "الموظف مؤرشف بالفعل.": "The employee is already archived.",
  "الموظف غير مؤرشف.": "The employee is not archived.",
  "تمت الإضافة": "Created",
  "تم التعديل": "Updated",
  "تم الحذف": "Deleted",
  "تمت الأرشفة": "Archived",
  "تمت الاستعادة": "Restored",
  "تمت المشاركة": "Shared",
  موظف: "Staff",
  مالك: "Owner",
  نشط: "Active",
  "سيُزال الشعار عند الحفظ.": "The logo will be removed when you save.",
  تراجع: "Undo",
  "PNG أو JPG، بحد أقصى 1 ميجابايت": "PNG or JPG, up to 1 MB",
  "لا شيء في الشهرين": "Nothing in either month",
  "لا شيء في الشهر السابق": "Nothing in the previous month",
  "بدون تغيير عن الشهر السابق": "No change from the previous month",
  "{n}% أكثر من الشهر السابق": "{n}% more than the previous month",
  "{n}% أقل من الشهر السابق": "{n}% less than the previous month",
  "المسلَّم فعلاً": "Handed over",
  "سلف جديدة": "New advances",
  "التقرير الشهري": "Monthly report",
  "المستحق للموظفين": "Earned by employees",
  "الاستقطاعات المأخوذة": "Deductions taken",
  "المستحق هو أجور أيام الشهر مع الإكراميات. المسلَّم فعلاً يُحسب بتاريخ التسليم بعد الاستقطاع، فقد يختلف عن المستحق إذا سُلّمت رواتب في شهر غير شهر العمل.":
    "Earned is the wages for the month's days plus tips. Handed over is counted by the day it was handed over, after deductions, so it can differ from earned when pay is handed over in a different month than the work.",
  "الموظفون في هذا الشهر": "Employees this month",
  "لا توجد أي حركة في هذا الشهر.": "No activity in this month.",
  "مجموع رواتب الشهر وما سُلّم فعلاً والاستقطاعات والسلف والطعام مع مقارنة بالشهر السابق.":
    "The month's pay, what was actually handed over, deductions, advances and food, compared with the previous month.",
  "{days} يوم غير مسلَّم منذ {since}، بقيمة {amount}":
    "{days} unpaid days since {since}, worth {amount}",
  "يوم مسجّل مرتين ({n})": "day recorded twice ({n})",
  "يوم بدون أجر ({n})": "day with no wage ({n})",
  "تاريخ غير صحيح ({n})": "impossible date ({n})",
  "عليه {owed} ودخله في آخر 4 أسابيع {earned}": "owes {owed}, earned {earned} in the last 4 weeks",
  "عمل {n} أيام الأسبوع الماضي ولا يوجد تسجيل هذا الأسبوع":
    "worked {n} days last week, nothing recorded this week",
  "رواتب متأخرة لم تُسلَّم": "Overdue pay not handed over",
  "بيانات تحتاج مراجعة": "Records to check",
  "استقطاعات أكبر من دخل آخر 4 أسابيع": "Deductions bigger than 4 weeks of pay",
  "لم يُسجَّل لهم عمل هذا الأسبوع": "No work recorded this week",
  "عرض أقل": "Show less",
  "عرض الكل ({n})": "Show all ({n})",
  "و {n} آخرين": "and {n} more",
  "تنبيهات قبل يوم الدفع": "Checks before payday",
  "تعذر تحميل التنبيهات.": "Could not load the checks.",
  "لا توجد تنبيهات. كل شيء يبدو سليماً.": "Nothing to check. Everything looks fine.",
  "{n}% أكثر من السنة السابقة": "{n}% more than the previous year",
  "{n}% أقل من السنة السابقة": "{n}% less than the previous year",
  "بدون تغيير عن السنة السابقة": "No change from the previous year",
  "لا شيء في السنة السابقة": "Nothing in the previous year",
  "لا شيء في السنتين": "Nothing in either year",
  "{n}% أكثر من الفترة السابقة": "{n}% more than the previous period",
  "{n}% أقل من الفترة السابقة": "{n}% less than the previous period",
  "بدون تغيير عن الفترة السابقة": "No change from the previous period",
  "لا شيء في الفترة السابقة": "Nothing in the previous period",
  "لا شيء في الفترتين": "Nothing in either period",
  شهر: "Month",
  سنة: "Year",
  "فترة مخصصة": "Custom period",
  "اختر تاريخ البداية والنهاية.": "Choose the start and end dates.",
  "تاريخ البداية قديم جداً.": "The start date is too far back.",
  "الفترة لا يمكن أن تتجاوز {n} سنوات.": "The period cannot be longer than {n} years.",
  الشهر: "Month",
  "نوع الفترة": "Type of period",
  "السنة السابقة": "Previous year",
  "السنة التالية": "Next year",
  "السنة الحالية": "Current year",
  عرض: "Show",
  "الفترة من {from} إلى {to}": "Period from {from} to {to}",
  "({n} يوماً)": "({n} days)",
  "حسب الشهر": "By month",
  "لا توجد أي حركة في هذه الفترة.": "No activity in this period.",
  "الموظفون في هذه الفترة": "Employees in this period",
  "المستحق هو أجور أيام الفترة مع الإكراميات. المسلَّم فعلاً يُحسب بتاريخ التسليم بعد الاستقطاع، فقد يختلف عن المستحق إذا سُلّمت رواتب في فترة غير فترة العمل.":
    "Earned is the wages for the period's days plus tips. Handed over is counted by the day it was handed over, after deductions, so it can differ from earned when pay is handed over in a different period than the work.",
  "عرض شهر محدد": "Show one month",
  "عرض كل الفترات": "Show all periods",
  "إضافة صيانة": "Add maintenance",
  العناصر: "Items",
  "كل العناصر": "All items",
  تمت: "Done",
  مجدولة: "Planned",
  "مشكلة، ورشة، شخص ...": "Problem, workshop, person ...",
  "المصروف على الصيانة": "Spent on maintenance",
  "{n} عمل منجز": "{n} finished jobs",
  "أعمال مجدولة": "Planned jobs",
  "التكلفة المتوقعة": "Expected cost",
  "عدد العناصر المصانة": "Items maintained",
  "فيها أعمال منجزة في هذه الفترة": "with finished jobs in this period",
  "التكاليف المنجزة وحدها تدخل في المصروف. الدينار والدولار لا يُجمعان ولا يُحوّلان.":
    "Only finished jobs count as spent. Dinars and dollars are never added together or converted.",
  "المصروف حسب العنصر": "Spent by item",
  "{n} عمل": "{n} jobs",
  "يُعرض أحدث 1000 سجل فقط. ضيّق الفترة أو استخدم البحث. الإجماليات تشمل كل السجلات.":
    "Only the latest 1000 records are shown. Narrow the period or use search. Totals include all records.",
  "لا توجد نتائج مطابقة.": "No matching records.",
  "لا توجد صيانة مسجلة في هذه الفترة.": "No maintenance recorded in this period.",
  "مجدولة وتأخرت": "Planned and late",
  "ما تم عمله": "Work done",
  "من أصلحها": "Fixed by",
  "الصيانة القادمة": "Next maintenance",
  التكلفة: "Cost",
  "تسجيل كمنجزة": "Mark as done",
  "تعديل صيانة {name}": "Edit maintenance of {name}",
  "حذف صيانة {name}": "Delete maintenance of {name}",
  "هل أنت متأكد أنك تريد حذف سجل الصيانة هذا؟":
    "Are you sure you want to delete this maintenance record?",
  "أدخل التكلفة (اكتب 0 إذا لم تكن هناك تكلفة).": "Enter the cost (write 0 if there was no cost).",
  "اختر العنصر.": "Choose the item.",
  "اختر التاريخ.": "Choose the date.",
  "اكتب المشكلة.": "Describe the problem.",
  "الموعد القادم يجب أن يكون بعد تاريخ الصيانة.":
    "The next due date must be after the maintenance date.",
  "تعديل سجل صيانة": "Edit maintenance record",
  "مجدولة (لم تتم بعد)": "Planned (not done yet)",
  "اختر العنصر": "Choose the item",
  "أضف عنصراً أولاً من زر «العناصر».": 'Add an item first with the "Items" button.',
  "التاريخ المقرر": "Planned date",
  "تاريخ الصيانة": "Maintenance date",
  "ما المشكلة؟": "What is the problem?",
  "كيف تم الإصلاح؟ (ما تم عمله)": "How was it fixed? (work done)",
  "من قام بالإصلاح؟ (شخص أو ورشة)": "Who fixed it? (person or workshop)",
  "موعد الصيانة القادمة (اختياري)": "Next maintenance date (optional)",
  "يظهر تنبيه في الصفحة الرئيسية قبل الموعد بأسبوع.":
    "A reminder appears on the home page a week before the date.",
  معدّة: "Machine",
  موقع: "Site",
  أخرى: "Other",
  "عناصر الصيانة": "Maintenance items",
  "السيارات والمعدات والمواقع التي تُسجَّل لها الصيانة. العنصر الذي له سجلات لا يُحذف، بل يُؤرشف.":
    "The vehicles, machines and sites that maintenance is recorded for. An item with records is archived, not deleted.",
  "لا توجد عناصر بعد. أضف أول عنصر.": "No items yet. Add the first one.",
  "{n} سجل": "{n} records",
  "إعادة للخدمة": "Restore",
  "تعديل العنصر": "Edit item",
  "إضافة عنصر جديد": "Add a new item",
  "أدخل اسم العنصر.": "Enter the item's name.",
  النوع: "Type",
  "رقم السيارة أو الرقم التسلسلي": "Plate number or serial number",
  ملاحظات: "Notes",
  "حفظ التعديل": "Save changes",
  "إلغاء التعديل": "Cancel editing",
  الصيانة: "Maintenance",
  "تسجيل صيانة السيارات والمعدات: المشكلة وكيف أُصلحت ومن أصلحها وكم كلّفت ومتى، مع الصيانة المجدولة.":
    "Record repairs of vehicles and machines: the problem, how it was fixed, who fixed it, what it cost and when, plus planned maintenance.",
  "حان موعد الصيانة القادمة ({problem}) بتاريخ {due}": "Next maintenance due ({problem}) on {due}",
  "صيانة مجدولة ({problem}) بتاريخ {due}": "Planned maintenance ({problem}) on {due}",
  متأخرة: "late",
  "صيانة مستحقة": "Maintenance due",
  "فاتورة صيانة {name}": "Maintenance invoice: {name}",
  الفاتورة: "Invoice",
  "صورة الفاتورة: {name}": "Invoice image: {name}",
  تنزيل: "Download",
  "حُفظت الصيانة لكن تعذّر حفظ الفاتورة: {reason}":
    "The maintenance was saved, but the invoice could not be saved: {reason}",
  "نوع الملف غير مدعوم. استخدم صورة JPG أو PNG أو WebP، أو ملف PDF.":
    "Unsupported file type. Use a JPG, PNG or WebP image, or a PDF.",
  "حجم الملف ({size}) يتجاوز الحد المسموح (5 ميجابايت).":
    "The file size ({size}) is over the 5 MB limit.",
  "الفاتورة (صورة أو PDF، اختياري)": "Invoice (image or PDF, optional)",
  "الفاتورة الحالية": "Current invoice",
  "إزالة الفاتورة": "Remove the invoice",
  "ستُزال الفاتورة عند الحفظ.": "The invoice will be removed when you save.",
  "لا يمكن استبدال هذه الفاتورة إلا لمن سجّل الصيانة أو لمالك الحساب.":
    "Only whoever recorded the maintenance or an owner account can replace this invoice.",
  "اختيار ملف آخر": "Choose another file",
  "اختيار ملف": "Choose a file",
  "عرض فاتورة {name}": "View invoice of {name}",
  "اكتب عدداً صحيحاً من 1 إلى {max}.": "Enter a whole number from 1 to {max}.",
  "صيانة متكررة": "Repeating service",
  "تتكرر كل": "Repeats every",
  الوحدة: "Unit",
  أشهر: "months",
  أيام: "days",
  "عند الحفظ تُجدول الصيانة التالية تلقائياً بتاريخ {date}.":
    "When you save, the next service is planned automatically for {date}.",
  "عند تسجيلها كمنجزة تُجدول الصيانة التالية تلقائياً.":
    "When it is marked as done, the next service is planned automatically.",
  التكرار: "Repeats",
  "كل {n} شهر": "every {n} months",
  "كل {n} يوم": "every {n} days",
  "العودة إلى الصيانة": "Back to maintenance",
  "هذا العنصر غير موجود.": "This item does not exist.",
  "إجمالي ما صُرف عليه": "Total spent on it",
  "متوسط المدة بين صيانتين": "Average time between services",
  "يحتاج إلى صيانتين منجزتين على الأقل": "Needs at least two finished services",
  "{n} يوم": "{n} days",
  "آخر صيانة": "Last service",
  "صيانة مجدولة": "Planned maintenance",
  الأقرب: "Nearest",
  "المصروف حسب السنة": "Spent by year",
  "لا توجد أعمال منجزة بعد.": "No finished jobs yet.",
  السنة: "Year",
  الأعمال: "Jobs",
  المصروف: "Spent",
  "حسب من أصلح": "By who fixed it",
  "الورشة أو الشخص": "Workshop or person",
  "كل الأعمال": "All jobs",
  "يُعرض أحدث 1000 سجل فقط. الإجماليات تشمل كل السجلات.":
    "Only the latest 1000 records are shown. Totals include all records.",
  "لا توجد صيانة مسجلة لهذا العنصر.": "No maintenance recorded for this item.",
  "رمز QR للعنصر {name}": "QR code of {name}",
  "تعذر تحميل الرمز.": "Could not load the code.",
  "رمز QR لهذا العنصر": "QR code for this item",
  "اطبع الملصق والصقه على العنصر. أي شخص يمسح الرمز بهاتفه يرى بيانات العنصر وسجل صيانته دون تسجيل دخول، ولا يرى التكاليف ولا الفواتير.":
    "Print the label and stick it on the item. Anyone who scans the code with a phone sees the item and its maintenance history without signing in, but not the costs or invoices.",
  "الصيانة تُحسب بتاريخ إنجاز العمل، والأعمال المنجزة فقط. الدينار والدولار لا يُجمعان ولا يُحوّلان.":
    "Maintenance is counted by the day the job was finished, finished jobs only. Dinars and dollars are never added together or converted.",
  "المصروف على الصيانة في آخر 12 شهراً": "Maintenance spending in the last 12 months",
  "المجموع: {amount}": "Total: {amount}",
  "المصروف حسب الشهر": "Spending by month",
  "أكثر العناصر تكلفة": "Items that cost the most",
  "({n})": "({n})",
  "تم إرسال البلاغ. شكراً لك، سيراجعه المسؤول.":
    "Report sent. Thank you, the manager will look at it.",
  "اكتب المشكلة (3 أحرف على الأقل).": "Describe the problem (at least 3 characters).",
  "هل في العنصر مشكلة؟": "Is something wrong with this item?",
  "{n} بلاغ مفتوح على هذا العنصر بانتظار المراجعة.":
    "{n} open reports on this item are waiting for review.",
  "الإبلاغ عن مشكلة": "Report a problem",
  "اسمك (اختياري)": "Your name (optional)",
  "جاري الإرسال...": "Sending...",
  "إرسال البلاغ": "Send the report",
  "بلاغات من رمز QR": "Reports from QR labels",
  "تسجيل صيانة": "Record maintenance",
  "تم الحل": "Mark as solved",
  "حذف البلاغ": "Delete the report",
  "بلاغات أعطال من رمز QR": "Problems reported from QR labels",
  "هذا الرمز غير صالح أو أن العنصر حُذف.": "This code is not valid, or the item was deleted.",
  "أعمال منجزة": "Finished jobs",
  "سجل الصيانة": "Maintenance history",
  "الموعد القادم": "Next due",
  "يُعرض أحدث 100 سجل فقط.": "Only the latest 100 records are shown.",
  "فتح الصفحة الكاملة (التكاليف والفواتير)": "Open the full page (costs and invoices)",
  "تسجيل الدخول لعرض التكاليف والفواتير": "Sign in to see costs and invoices",
  "جاري التجهيز...": "Preparing...",
  "تنزيل الملصق للطباعة (PDF)": "Download the label to print (PDF)",
  "تمت إضافة العنصر. هذا ملصق QR الخاص به:": "Item added. Here is its QR label:",
  "ملصق QR للعنصر:": "QR label for this item:",
  إخفاء: "Hide",
  "ملصق QR لـ {name}": "QR label for {name}",
  "ملصق QR": "QR label",
  "عرض المعلومات": "Show information",
  "المصروف والأعمال المجدولة": "Spending and planned jobs",
  "الرسوم البيانية": "Charts",
  "سجلات الصيانة": "Maintenance records",
  "تنزيل ملصق QR لـ {name}": "Download QR label for {name}",
  "تنزيل الملصق": "Download label",
  المشكلة: "Problem",
};

export default en;
